import { HttpHeaders } from '@angular/common/http';

export function getHeaders(): HttpHeaders {
  let headers = new HttpHeaders().set('Accept', 'application/json');
  try {
    const raw = localStorage.getItem('currentUser');
    if (raw) {
      let token: string | null = null;
      try {
        const user = JSON.parse(raw);
        token = user?.token ?? user?.accessToken ?? null;
      } catch {
        // Si el JSON está corrupto, no bloquear: limpiar la entrada para evitar bucles
        try { localStorage.removeItem('currentUser'); } catch {}
      }
      if (token && typeof token === 'string') {
        headers = headers.set('Authorization', token);
      }
    }
  } catch {
    // Acceso a localStorage falló (Safari Modo Privado u otros): continuar sin auth
  }
  return headers;
}